module.exports = __webpack_public_path__ + "static/images/containers/Challenges/components/Status/images/line_light_wrapped.536c9520.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Challenges/components/Status/images/line_light_wrapped.png
// module id = 2865
// module chunks = 11